import debug from 'debug';
import Settings from '../data/settings';
import Shops from './shops';

const log = debug('SearchBox:Utils:SearchUrl');

class SearchUrl {
	/**
	 * @param {string} term The search term
	 */
	static get(term) {
		return `${Settings.searchUrl}?${Settings.searchQueryParam}=${encodeURIComponent(term)}${Shops.get()}`;
	}
}

export default SearchUrl;
